import { put, race, select, takeEvery } from 'redux-saga/effects';
import { getFormValues, startSubmit, stopSubmit } from 'redux-form';
import { push } from 'connected-react-router';
import { length, path, pipe } from 'ramda';

import {
  practitionersAdd,
  requestPractitionersGetByLogin,
  requestPractitionersCreate,
} from 'store/actionCreators/practitioners';
import { FORM_NAMES } from 'constants/forms';
import { FHIR_VALUE_ROLES } from 'constants/userRoles';
import { createSagaRequestRace } from 'utilities/request';

import moment from 'moment';

export function createFhirOrganizationObject({
  firstName,
  lastName,
  password,
  role,
  username,
  email,
}) {
  return {
    smileModel: {
      role,
      username,
      password,
    },
    fhirModel: {
      resourceType: 'Practitioner',
      id: username,
      telecom: [
        {
          system: 'email',
          value: email,
          rank: 1,
        },
      ],
      name: [
        {
          use: 'usual',
          text: `${firstName} ${lastName}`,
          family: lastName,
          given: [firstName],
        },
      ],
      qualification: [FHIR_VALUE_ROLES[role]],
      extension: [
        {
          url: 'created-on',
          valueDateTime: moment().format('YYYY-MM-DDThh:mm:ss.000Z'),
        },
      ],
    },
  };
}

export function* onPractitionersAdd() {
  yield put(startSubmit(FORM_NAMES.addPractitioner));
  const values = yield select(getFormValues(FORM_NAMES.addPractitioner));

  yield put(requestPractitionersGetByLogin({ username: values.username }));
  const { success: getUsersSuccess } = yield race(
    createSagaRequestRace(requestPractitionersGetByLogin),
  );

  if (
    pipe(
      path(['payload', 'response', 'users']),
      length,
    )(getUsersSuccess)
  ) {
    yield put(
      stopSubmit(FORM_NAMES.addPractitioner, {
        username: 'Username is already taken',
      }),
    );
    return;
  }

  const organizationObject = createFhirOrganizationObject(values);
  yield put(requestPractitionersCreate({ data: organizationObject }));
  const { success: createSuccess } = yield race(createSagaRequestRace(requestPractitionersCreate));

  yield put(stopSubmit(FORM_NAMES.addPractitioner));
  if (createSuccess) {
    yield put(push('/'));
  }
}

export default function*() {
  yield takeEvery(practitionersAdd, onPractitionersAdd);
}
